/** @format */

import React, { Component } from 'react';
import { Menu, Form, Button, Icon } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { getUnixDateFromTimestamp } from '../../../helpers/getUnixDateFromTimestamp';
import { getTimestamp } from '../../../helpers/getTimestamp';
import './StatisticsToolbar.css';

import { inject, observer } from 'mobx-react';

@inject('StatsStore')
@observer
class StatisticsToolbar extends Component {
  render() {
    const { StatsStore } = this.props;
    const { start, end } = StatsStore.stats.timeInterval;
    return (
      <Menu className="sales-toolbar" borderless size="tiny">
        <Menu.Menu>
          <Menu.Item>
            <Form.Input
              inline
              size="mini"
              name="end"
              max={getUnixDateFromTimestamp(start)}
              value={getUnixDateFromTimestamp(end)}
              onChange={e => {
                let date = e.target.value + ' 00:00:00';
                StatsStore.timeIntervalInput(date, e.target.name);
              }}
              label="Dal "
              type="date"
            />
          </Menu.Item>
          <Menu.Item>
            <Form.Input
              inline
              size="mini"
              name="start"
              onChange={e => {
                let date = e.target.value + ' 23:59:59';
                StatsStore.timeIntervalInput(date, e.target.name);
              }}
              min={getUnixDateFromTimestamp(end)}
              max={getUnixDateFromTimestamp(getTimestamp())}
              value={getUnixDateFromTimestamp(start)}
              label="Al "
              type="date"
            />
          </Menu.Item>
        </Menu.Menu>
        <Menu.Menu position="right">
          <Menu.Item />
          <Menu.Item>
            <Button onClick={() => this.props.refresh()} color="green">
              <Icon name="refresh" />
              Aggiorna
            </Button>
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    );
  }
}

export default withRouter(StatisticsToolbar);
